import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import commingSoon from "../../images/coming-soon.png";

const Ongoing = () => {
  return (
    <>
      <div style={{ width: "100%", height: "100vh", position: "relative" }}>
        <img
          style={{ height: "100vh" }}
          className="w-100"
          src={commingSoon}
          alt="coming soon"
        />
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
          className="back-btn text-center"
        >
          <Link to="/">
            <Button className="btn">GO BACK</Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Ongoing;
